module.exports = __webpack_public_path__ + "static/img/speed-one.a2ab2ea8.jpg";